import { ClientCriticalErrorTypes } from './types/ClientCriticalErrorTypes'

/**
 * This error means some critical error with some of blocks
 *
 * Example of critical error: Parsing of URLSearchParams on home/room-offer pages
 *
 * We can't just ignore this error, because it will cause infinity render or
 * something other
 */
export class ClientCriticalError extends Error {
	type: ClientCriticalErrorTypes

	constructor(type: ClientCriticalErrorTypes, message: string) {
		super(message)
		this.type = type
	}
}
